<template>
  <button class="adv-add-to-cart-button-base add-to-cart-btn" :disabled="disabled" @click="addToCart">{{ buttonText }}</button>
</template>

<script>

export default {
  name: 'AdvAddToCartButtonBase',
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    buttonText: {
      type: String,
      required: true
    }
  },
  methods: {
    addToCart () {
      this.$emit('add-to-cart')
    }
  }
}
</script>

<style lang="scss" scoped>
.adv-add-to-cart-button-base {
  color: white;
  width: 90%;
  margin-left:auto;
  border-radius: 10px;
  transition: all 500ms ease-in-out;
}
</style>
